export const useDataDogTest = () => {
  const { $dataDogTest } = useNuxtApp()

  return {
    isDataDogTest: $dataDogTest.isEnabled,
  }
}
